module.exports = [
    [   // 1- Cubes
        { image: require('../assets/WISC4-Images/WISC4-00-00-Cubes.png')},
        { image: require('../assets/WISC4-Images/WISC4-00-01-Cubes.png')},
        { image: require('../assets/WISC4-Images/WISC4-00-02-Cubes.png')},
        { image: require('../assets/WISC4-Images/WISC4-00-03-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-04-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-05-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-06-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-07-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-08-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-09-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-10-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-11-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-12-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-13-Cubes.jpg')},
        { image: require('../assets/WISC4-Images/WISC4-00-14-Cubes.jpg')},
    ],
    [   // 2- Similarities
        { image: require('../assets/WISC4-Images/WISC4-01-00-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-01-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-02-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-03-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-04-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-05-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-06-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-07-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-08-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-09-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-10-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-11-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-12-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-13-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-14-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-15-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-16-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-17-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-18-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-19-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-20-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-21-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-22-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-23-Similarities.png')},
        { image: require('../assets/WISC4-Images/WISC4-01-24-Similarities.png')},
    ],
    [   // 3- Sequencing
        { image: require('../assets/WISC4-Images/WISC4-02-00-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-01-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-02-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-03-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-04-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-05-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-06-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-07-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-08-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-09-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-10-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-11-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-12-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-13-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-14-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-15-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-16-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-17-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-18-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-19-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-20-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-21-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-22-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-23-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-24-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-25-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-26-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-27-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-28-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-29-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-30-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-31-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-32-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-33-Sequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-02-34-Sequencing.png')},
    ],
    [   // 4- Concepts
        { image: require('../assets/WISC4-Images/WISC4-03-00-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-01-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-02-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-03-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-04-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-05-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-06-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-07-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-08-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-09-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-10-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-11-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-12-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-13-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-14-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-15-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-16-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-17-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-18-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-19-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-20-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-21-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-22-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-23-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-24-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-25-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-26-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-27-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-28-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-29-Concepts.png')},
        { image: require('../assets/WISC4-Images/WISC4-03-30-Concepts.png')},
    ],
    [   // 5- Coding
        { image: require('../assets/WISC4-Images/WISC4-04-00-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-01-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-03-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-06-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-07-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-08-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-09-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-10-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-11-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-12-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-13-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-14-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-15-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-16-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-17-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-18-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-19-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-20-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-21-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-22-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-23-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-24-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-25-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-26-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-27-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-28-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-29-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-30-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-31-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-32-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-33-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-34-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-35-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-36-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')}, // square
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')}, // star
        { image: require('../assets/WISC4-Images/WISC4-04-03-Coding.png')}, // circle
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')}, // triangle
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-06-Coding.png')}, // shape
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-03-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-06-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-06-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-03-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-04-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-03-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-05-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-06-Coding.png')},
        { image: require('../assets/WISC4-Images/WISC4-04-02-Coding.png')},
    ],
    [   // 6- Vocabulary
        { image: require('../assets/WISC4-Images/WISC4-05-00-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-01-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-02-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-03-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-04-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-05-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-06-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-07-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-08-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-09-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-10-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-11-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-12-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-13-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-14-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-15-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-16-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-17-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-18-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-19-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-20-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-21-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-22-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-23-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-24-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-25-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-26-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-27-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-28-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-29-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-30-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-31-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-32-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-33-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-34-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-35-Vocabulary.png')},
        { image: require('../assets/WISC4-Images/WISC4-05-36-Vocabulary.png')},
    ],
    [   // 7- AlphaNum Sequencing
        { image: require('../assets/WISC4-Images/WISC4-06-00-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-01-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-02-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-03-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-04-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-05-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-06-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-07-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-08-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-09-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-10-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-11-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-12-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-13-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-14-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-15-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-16-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-17-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-18-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-19-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-20-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-21-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-22-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-23-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-24-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-25-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-26-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-27-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-28-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-29-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-30-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-31-AlphNumSequencing.png')},
        { image: require('../assets/WISC4-Images/WISC4-06-32-AlphNumSequencing.png')},
    ],
    [   // 8- Matrices
        { image: require('../assets/WISC4-Images/WISC4-07-00-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-01-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-02-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-03-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-04-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-05-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-06-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-07-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-08-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-09-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-10-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-11-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-12-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-13-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-14-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-15-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-16-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-17-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-18-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-19-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-20-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-21-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-22-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-23-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-24-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-25-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-26-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-27-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-28-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-29-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-30-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-31-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-32-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-33-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-34-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-35-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-36-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-37-Matrices.png')},
        { image: require('../assets/WISC4-Images/WISC4-07-38-Matrices.png')},
    ],
    [   // 9- Comprehension
        { image: require('../assets/WISC4-Images/WISC4-08-00-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-01-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-02-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-03-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-04-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-05-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-06-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-07-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-08-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-09-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-10-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-11-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-12-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-13-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-14-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-15-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-16-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-17-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-18-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-19-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-20-Comprehension.png')},
        { image: require('../assets/WISC4-Images/WISC4-08-21-Comprehension.png')},
    ],
    [   // 10- Symbol
        { image: require('../assets/WISC4-Images/WISC4-09-00-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-02-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-04-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-05-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-06-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-03-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-07-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
        { image: require('../assets/WISC4-Images/WISC4-09-01-Symbol.png')},
    ],
    [   // 11- Completion
        { image: require('../assets/WISC4-Images/WISC4-10-00-Completion.png')},
        { image: require('../assets/WISC4-Images/WISC4-10-01-Completion.png')},
    ],
    [   // 12- Cancellation
        { image: require('../assets/WISC4-Images/WISC4-11-00-Cancellation.png')},
        { image: require('../assets/WISC4-Images/WISC4-11-01-Cancellation.png')},
    ],
    [   // 13- General
        { image: require('../assets/WISC4-Images/WISC4-12-00-General.png')},
        { image: require('../assets/WISC4-Images/WISC4-12-01-General.png')},
    ],
    [   // 14- Arithmetic
        { image: require('../assets/WISC4-Images/WISC4-13-00-Arithmetic.png')},
        { image: require('../assets/WISC4-Images/WISC4-13-01-Arithmetic.png')},
        { image: require('../assets/WISC4-Images/WISC4-13-02-Arithmetic.png')},
        { image: require('../assets/WISC4-Images/WISC4-13-03-Arithmetic.png')},
        { image: require('../assets/WISC4-Images/WISC4-13-04-Arithmetic.png')},
        { image: require('../assets/WISC4-Images/WISC4-13-05-Arithmetic.png')},
        { image: 'رضا ۵ کتاب داشت یکی از آن‌ها را گم کرد، حالا او چند کتاب دارد؟'},
        { image: '۲ پاک‌کن و ۳ پاک‌کن روی هم چند تا می‌شود؟'},
        { image: 'علی ۵ کیک داشت. یک کیک را به حسن داد و یکی را به حسین، چند کیک برایش باقی مانده است؟'},
        { image: 'اگر یک سیب را از وسط نصف کنیم، چند تکه سیب خواهیم داشت؟'},
        { image: 'بابک ۴ کشک داشت مادرش هم دو کشک به او داد. او روی هم چند کشک دارد؟'},
        { image: 'اگر شما ۳ مداد در هر دستتان داشته باشید روی هم چند مداد دارید؟'},
        { image: 'اگر شما ۱۰ شکلات داشته باشید و ۳ تای آن را بخورید، چند شکلات برایتان باقی می‌ماند؟'},
        { image: 'سه ماشین در پارکینگی که در آن ۱۲ ماشین وجود داشتند وارد شدند، حالا روی هم چند ماشین در پارکینگ پارک شده است؟'},
        { image: 'تقی ۸ خودکار داشت ۶ خودکار دیگر هم خرید، او روی هم چند خودکار دارد؟'},
        { image: 'زهرا ۴ پرتقال از یک مغازه خرید و ۲ پرتغال نیز از مغازه دیگری خرید، مادرش هم به او ۳ پرتغال داد. او روی هم چند پرتغال دارد؟'},
        { image: 'زهرا ۱۰ آدامس در روز دوشنبه و ۱۵ تا در روز سه‌شنبه خرید. او روی هم چند آدامس خرید؟'},
        { image: 'کامران ۱۲ بادکنک داشت، ۵ تای آن‌ها ترکید. چند بادکنک برایش باقی ماند؟'},
        { image: 'سه گوسفند در مزرعه‌ای می‌چریدند، ۴ گوسفند دیگر نیز وارد آن مزرعه شدند و ۲ گوسفند از آن مزرعه خارج شدند. حالا چند گوسفند در مزرعه باقی مانده؟'},
        { image: 'کبری ۸ پرنده را تماشا می‌کرد، ۴ تای آن‌ها پریدند و ۲ پرنده دیگر نیز کنار آن‌ها نشستند. حالا کبری چند پرنده می‌بیند؟'},
        { image: 'محمد در یک بازی ۱۷ امتیاز و در بازی دیگر ۱۵ امتیاز به دست آورد. او روی هم چند امتیاز به دست آورد؟'},
        { image: '۳۰ دانش‌آموز در کلاسی ثبت نام کرده بودند. بعد از یک هفته ۱۱ دانش‌آموز از آن کلاس رفتند. چند دانش‌آموز در کلاس باقی ماندند؟'},
        { image: 'در یک جعبه ۸ ردیف مدادتراش وجود دارد. اگر در هر ردیف ۳ مدادتراش باشد، چند مدادتراش در جعبه وجود دارد؟'},
        { image: 'شیرین ۳۰ آب‌نبات چوبی داشت، نیمی از آن‌ها را خورد و بقیه را بین ۵ نفر تقسیم کرد. به هر نفر چند آب‌نبات چوبی رسیده است؟'},
        { image: 'علی به ۳ نفر از دوستانش هر نفر ۲ گردو داد، به برادرش نیز ۷ گردو داد. اگر علی بیست گردو داشته باشد، برای خودش چند گردو باقی مانده است؟'},
        { image: 'علی دو بستنی ۴۰ تومانی خرید. او چند ریال پول داده است؟'},
        { image: 'جهان دو برابر یوسف پول دارد، اگر جهان ۱۷ تومان داشته باشد، یوسف چقدر پول دارد؟'},
        { image: 'در یک مدرسه در هر کلاس ۲۵ دانش‌آموز است. اگر در این مدرسه ۵۰۰ دانش‌آموز وجود داشته باشد، این مدرسه چند کلاس دارد؟'},
        { image: 'راننده‌ای ۳ ساعت رانندگی کرد. پس از استراحت دوباره ۲ ساعت رانندگی کرد. اگر در این مدت او ۳۰۰ کیلومتر رانندگی کرده باشد، متوسط سرعت او چقدر است؟'},
        { image: 'سن علی دو سوم (به صورت کسری) سن حسن است. اگر علی ۲۰ سال داشته باشد، سن حسن چقدر است؟'},
        { image: 'دمای هوا بین ساعت ۴ تا ۸ صبح ۱۲ درجه افزایش یافت. از ساعت ۸ تا ۱۱ عصر نیز ۹ درجه بالا رفت. به طور متوسط دمای هوا در هر ساعت چند درجه بالا رفته است؟'},
        { image: 'از ۴۰ نفر دانش‌آموزان یک کلاس امتحان ریاضی گرفته شد و ۱۵ درصد نمره قبولی نیاوردند. چند نفر از دانش‌آموزان کلاس نمره قبولی آوردند؟'},
        { image: '۶ نفر می‌توانند ۴۰ ماشین را در ۴ روز بشویند. اگر بخواهیم این ۴۰ ماشین را در نصف روز بشوییم، به چند نفر نیاز داریم؟'},
        { image: 'شاهین می‌تواند طی ۲ ساعت با هواپیما به فرودگاه برسد و خانه جلیل تا فرودگاه ۱۵۰ کیلومتر فاصله دارد. جلیل می‌خواهد ۳۰ دقیقه قبل از رسیدن شاهین در فرودگاه باشد. اگر او با سرعت ۶۰  کیلومتر در ساعت رانندگی کند و هواپیمای شاهین ساعت ۳ اه بیفتد، جلیل چه ساعتی باید خانه‌اش را ترک کند؟'},
        { image: 'داریوش یک ساعت قبل از جواد محل کارش را ترک می‌کند. داریوش با سرعت ۴۰ کیلومتر در ساعت و جواد با سرعت ۶۰ کیلومتر در ساعت رانندگی می‌کند. اگر آن‌ها در یک جهت رانندگی کنند، پنج ساعت بعد از اینکه داریوش محل کارش را ترک کرد، جواد چند کیلومتر از او جلوتر است؟'},
    ],
    [   // 15- Verbal
        { image: require('../assets/WISC4-Images/WISC4-14-00-Verbal.png')},
        { image: require('../assets/WISC4-Images/WISC4-14-01-Verbal.png')},
    ],
    [
        { image: null },
    ]
]